<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form
        @submit="addLivraison"
        :validation-schema="livraisonSchema"
        :keep-values="valuess"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de livraison
              </label>
              <Field
                name="dateLivr"
                type="date"
                :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"
              />
            </div>
            <ErrorMessage name="dateLivr" class="text-danger" />
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Commande Client <span class="text-danger">*</span>
              </label>
              <Field name="commandeClient" v-slot="{ field }">
              <Multiselect
                :options="commandeOptions"
                :searchable="true"
                track-by="label"
                label="label"
                v-model="selectedCommande"
                @update:modelValue="field.onChange"
                :value="field.value"
                placeholder="Sélectionner la commande"
              />
            </Field>
            <ErrorMessage name="commandeclient" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Livreur <span class="text-danger">*</span>
              </label>
              <Field name="user" v-slot="{ field }">
                <Multiselect
                  :options="userOptions"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner le livreur"
                />
              </Field>
            <ErrorMessage name="user" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12 m-10">
              <div class="row">
                <div class="border border-primary mb-10">
                  <div class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                    <div class="col-md-7">
                      <h4 class="fs-4 text-white">Livraison</h4>
                    </div>
                    <div class="col-md-5">
                      <div class="d-flex float-end">
                        <button
                          class="btn btn-success"
                          type="button"
                          :class="{ 'cursor-not-allowed': isDisable }"
                          :disabled="isDisable"
                          @click="addRowMagasin()">
                          <i class="fa fa-plus-circle position-relative me-1 fs-12" ></i>Ajouter un magasin
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="accordion dark-accordion my-3 py-7"  id="magasin">
                      <div class="accordion-item accordion-wrapper" v-for="(magasin, magasinIndex) in magasins" :key="magasinIndex">
                        <h2 class="accordion-header" :id="`magasin${magasinIndex}`">
                          <button :class="`accordion-button bg-light-primary font-primary ${magasins.length == magasinIndex+1 ? '' :'collapsed'}`" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${magasinIndex}`" :aria-expanded="`${magasins.length == magasinIndex+1 ? true :false}`" :aria-controls="`collapse${magasinIndex}`">
                            {{ magasin.nomMagasin ? magasin.nomMagasin: `Magasin ${magasinIndex+1}`}}
                            <i class="vue-feather vue-feather--chevron-down svg-color" data-name="chevron-down" data-tags="expand" data-type="chevron-down"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down vue-feather__content"><polyline points="6 9 12 15 18 9"></polyline></svg></i>
                          </button>
                        </h2>
                        <div :class="`accordion-collapse collapse ${magasins.length == magasinIndex+1 ? 'show' :''}`" :id="`collapse${magasinIndex}`" :aria-labelledby="`magasin${magasinIndex}`" data-bs-parent="#magasin" style="">
                          <div class="accordion-body">
                            <div class="row" >
                              <div class="col-md-10 mb-2">
                                <div class="">
                                  <Multiselect
                                    :options="magasinOptions"
                                    :searchable="true"
                                    track-by="label"
                                    label="label"
                                    v-model="magasin.magasin"
                                    placeholder="Sélectionner le magasin"
                                   @select="selectMag(magasin.magasin, magasin, magasinIndex)"
                                    
                                  />
                                </div>
                                <div v-if="magasin.erreur" class="text-danger mt-1">
                                  {{ magasin.erreur }}
                                </div>
                              </div>
                              <div class="col-md-2">
                                <button
                                  class="btn btn-danger transition border-0 pb-2 ps-8 pe-8"
                                  type="button" @click="removeRowMagasin(magasinIndex)">
                                  <i class="fa fa-trash-o lh-1 me-1 position-relative top-2" ></i>
                                </button>
                              </div>
                            </div>
                            <div class="border border-primary mb-10">
                              <div class="row gx-0 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                                <div class="col-md-7">
                                  <h5 class="fs-6 mx-1 text-white">Ajouter les produits dans le magasin</h5>
                                </div>
                                <div class="col-md-5">
                                  <div class="d-flex float-end">
                                    <button
                                      class="btn btn-sm btn-success"
                                      type="button"
                                      @click="addRowProduit(magasinIndex)"><i class="fa fa-plus-circle position-relative me-1 fs-12"></i
                                      >Ajouter un produit
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="p-3">
                              <div class="row mt-10">
                                <div class="col-md-5">
                                  <label
                                    class="d-block text-black fw-semibold">
                                    Produit
                                    <span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    Quantité à livrée<span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold mb-10" >
                                    Quantité livrée
                                  </label>
                                </div>
                                 <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold mb-10" >
                                    Quantité restante
                                  </label>
                                </div>
                                
                                <div class="col-md-1">
                                  <label class="d-block text-black fw-semibold mb-10" >
                                    Action
                                  </label>
                                </div>
                                <hr class="mt-0" />
                              </div>
                              <div class="row gy-0"  v-for="(produit, produitIndex) in magasin.produits" :key="produitIndex"  >
                                <div class="col-md-5">
                                  <div class="form-group mb-2" >
                                    <Multiselect
                                      :options="magasin.produitOptions"
                                      :searchable="true"
                                      track-by="label"
                                      label="label"
                                      v-model="produit.produit"
                                      placeholder="Sélectionner le produit"
                                      @select="selectProd(produit.produit, produit, magasinIndex)" />
                                    <div
                                      class="invalid-feedback"
                                      v-if="validateRowProduit(produit.produit) " >
                                      Le produit est obligatoire.
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input
                                      type="number"
                                      v-model="produit.qtiteALivre"
                                      :class="
                                        validateRowProduit(produit.qtiteALivre)
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                          : 'form-control shadow-none fs-md-15 text-black'
                                      "
                                      placeholder="Entrer la quantité"
                                      readonly
                                    />
                                    <div v-if="validateRowProduit(produit.qtiteALivre)" class="invalid-feedback">
                                      La quantité à livrée est obligatoire.
                                    </div>
                                  </div>
                                </div>
                               <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input
                                      type="number"
                                      step="0.01"
                                      min="0"
                                      v-model.number="produit.qtiteLivre"
                                      :class="
                                        validateRowProduit(produit.qtiteLivre)
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                          : 'form-control shadow-none fs-md-15 text-black'
                                      "
                                      placeholder="Entrer la quantité (ex: 2.5)"
                                    />
                                    <div v-if="validateRowProduit(produit.qtiteLivre)" class="invalid-feedback">
                                      La quantité livrée est obligatoire.
                                    </div>
                                  </div>
                                </div>
                                  <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input
                                      type="number"
                                      v-model="produit.qtiteRestante"
                                      :class="
                                        validateRowProduit(produit.qtiteRestante ,'qtiteRestante')
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                          : 'form-control shadow-none fs-md-15 text-black'
                                      "
                                      placeholder="Entrer la quantité"
                                    />
                                    <div v-if="validateRowProduit(produit.qtiteRestante , 'qtiteRestante')" class="invalid-feedback">
                                      La quantité restante est obligatoire.
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-1 mb-1">
                                  <button
                                    class="btn btn-danger transition border-0 pb-2 ps-8 pe-8"
                                    type="button"
                                    @click="removeRowProduit(magasinIndex, produitIndex)" >
                                    <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                  </button>
                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button
                class="btn btn-success me-3"
                type="submit"
                :disabled="isDisable"
                :class="{ 'cursor-not-allowed': isDisable }"
              >
                Ajouter un livraison
              </button>
              <router-link
                to="/livraisons/liste-livraisons"
                class="btn btn-danger"
                ><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"
                ></i>
                <span class="position-relative"></span>Annuler</router-link
              >
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive } from "vue";
import { Form, Field, ErrorMessage, useFieldArray } from "vee-validate";
import { error, success, warning } from "@/utils/utils";
import { useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import * as Yup from "yup";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import { Livreur } from "@/models/Livreur";
import { StatutLivraison } from "@/constants/statutLivraison";

export default defineComponent({
  name: "AddLivraison",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    const livraisonSchema = Yup.object().shape({
      dateLivr: Yup.date().required("La date est obligatoire"),
      commandeClient: Yup.string().required("La commande est obligatoire"),
      user: Yup.string().required("Le livreur est obligatoire"),
    });

    const livraisonForm = ref<Livreur | null>(null);
    const router = useRouter();
    const commandeOptions = ref([]);
    const magasinOptions = ref([]);
    const produitOptions = ref([]);
    const userOptions=ref([]);
    const selectedCommande= ref('');
    // formulaire dynamique start
    const isDisable = ref(true);
    const magasins = reactive([
  {
    magasin: '',
    nomMagasin:'',
     erreur: '',
    produits: [],
    produitOptions: [],
  },
]);

const addRowMagasin = () => {
  magasins.push({
    magasin: '',
     erreur: '',
     nomMagasin:'',
    produits: [
      {
        produit: '',
        qtiteALivre: 0,
        qtiteLivre:0,
        qtiteRestante: 0,
        produitOptions: [],
      },
    ],
    produitOptions: [],
  });
};

const addRowProduit = (magasinIndex: number) => {
  magasins[magasinIndex].produits.push({
    produit: '',
    qtiteALivre: 0,
    qtiteLivre:0,
    qtiteRestante: 0,
    produitOptions: magasins[magasinIndex].produitOptions,
  });
};

const removeRowMagasin = (index: number) => {
  magasins.splice(index, 1);
};

const removeRowProduit = (magasinIndex: number, produitIndex: number) => {
  magasins[magasinIndex].produits.splice(produitIndex, 1);
};

const selectMag = (selectedMagasin: any, magasinCourant: any, magasinIndex: number) => {
  const selectedId = selectedMagasin.split('|')[0];

  const magasinExiste = magasins.some((m) => m !==magasinCourant && m.magasin.split('|')[0] === selectedId);
  
  if(magasinExiste){
     magasinCourant.erreur = 'Ce magasin a déjà été sélectionné.';
    magasinCourant.magasin = '';
    magasinCourant.produitOptions = [];

  }else{
    magasinCourant.magasin =selectedMagasin;
    magasinCourant.erreur = '';
    if(selectedCommande.value){
      fetchProduits(selectedCommande.value, selectedId,magasinIndex);
    }
  }

};

// const selectProd = (selectedProduit: string, produit: any) => {
//   produit.produit = selectedProduit;
  
//   // const prix = Number(selectedProduit.split("|")[2]);
//   // produit.prixRevient = isNaN(prix) ? 0 : prix;
//   produit.qtite =Number(selectedProduit.split("|")[3] || 0);; 
// };

const selectProd = (selectedProduit: string, produit: any, magasinIndex: number) => {
  produit.produit = selectedProduit;

  const selectedOption = magasins[magasinIndex].produitOptions.find(
    (option: any) => option.value === selectedProduit
  );

  if (selectedOption) {
    produit.qtiteALivre = Number(selectedOption.qtite || 0);
    produit.qtiteLivre = 0;
    produit.qtiteRestante = produit.qtite;
  } else {
    produit.qtiteALivre = 0;
    produit.qtiteLivre = 0;
    produit.qtiteRestante = 0;
  }

  console.log("Produit sélectionné", produit);
};

const validateRowProduit = (e: any, field?: any) => {
  if(field === 'qtiteRestante') {
    return e === '' || e == null || e < 0;
  }
  return e === '' || e === 0 || e === '0' || e == null || e < 0; 
};

  watch(
  magasins,
  (newValue) => {
    isDisable.value = newValue.some(
      (magasin) =>
        magasin.magasin === '' ||
        magasin.produits.some(
          (produit) =>
            validateRowProduit(produit.produit, 'produit') ||
            validateRowProduit(produit.qtiteALivre, 'qtiteALivre') ||
            validateRowProduit(produit.qtiteLivre, 'qtiteLivre') ||
            validateRowProduit(produit.qtiteRestante, 'qtiteRestante')
        )
    );
  },
  { deep: true }
);

    const { remove, push, fields, update } = useFieldArray("magasins");

    const magasinsss: any = ref(null);
    const valuess = ref();
    const userss: any = ref(null);



     const fetchMagasins = async () => {
      try {
        const response = await ApiService.get("/all/all/magasins");
        const magasinsData = response.data.data;
        magasinsss.value = magasinsData;
        magasinOptions.value = magasinsData.map((magasin) => ({
          value: magasin.id + "|" + magasin.nomMagasin,
          label: magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
        }));
      } catch (error) {
        //
      }
    };

      const fetchLivreurs = async () => {
      try {
        const response = await axios.get("/all/users");
        console.log("valll",response);
        const UserData = response.data.data;
         console.log("UserDataAAAA",UserData);
        userss.value = UserData;
        userOptions.value = UserData.map((user: any) => ({
          value:user.id + "|" + user.nom + "|" + user.prenom,
          label: `${user.nom} ${user.prenom}`,
        }));
      } catch (error) {
        //
      }
    };

   const fetchProduits = async (commandeId: string, magasinId: string, magasinIndex: number) => {
  try {
    const response = await ApiService.get(
        `/produitCommande/commandeClients/${commandeId}?magasinId=${magasinId}`
    );
    const produitsData = response.data.data;

    if (!produitsData || produitsData.length === 0) {
      magasins[magasinIndex].produitOptions = [];
      magasins[magasinIndex].produits = [];
      magasins[magasinIndex].erreur = '';
      warning("Aucun produit disponible pour ce magasin dans cette commande.");
      return;
    }

    magasins[magasinIndex].erreur = '';
    magasins[magasinIndex].produitOptions = produitsData.map((prod: any) => ({
      value: `${prod.id}|${prod.nomProCond}|${prod.qtite}|${prod.prodCondiId}`,
      label: prod.nomProCond,
      qtiteALivre: prod.qtite,
    }));

    magasins[magasinIndex].produits = produitsData.map((prod: any) => ({
      produit: `${prod.id}|${prod.nomProCond}|${prod.qtite}|${prod.prodCondiId}`,
      qtiteALivre: Number(prod.qtite || 0),
      qtiteLivre: 0,
      qtiteRestante: Number(prod.qtite || 0),
    }));

    magasins[magasinIndex].nomMagasin = produitsData[0].magasinNom;

  } catch (err) {
    magasins[magasinIndex].produitOptions = [];
    magasins[magasinIndex].produits = [];
    magasins[magasinIndex].erreur = '';
    error("Ce magasin n'a pas de produits pour cette commande.");
  }
};
    const idLivraison = ref(0);
    const typeCommande = ref(); 

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const addLivraison = async (values: any, { resetForm }: any) => {
      console.log('Dedans')
      values.magasins = magasins.map((magasin) => ({
        magasin: magasin.magasin.split('|')[0],
        produits: magasin.produits.map((produit) => ({
          produit: produit.produit.split('|')[0],
          qtiteALivre: produit.qtiteALivre,
          qtiteLivre: produit.qtiteLivre,
          qtiteRestante: produit.qtiteRestante,
          nomProd: produit.produit.split('|')[1],
        })),
      }));
      console.log('Données envoyées', values)
      ApiService.post("/livraisons", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeLivraison" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

   const fetchCommandes = async () => {
    try {
        const response = await ApiService.get("/commandeClients");
        const commandeData = response.data.data.data;

        commandeOptions.value = commandeData
            .filter((commande: any) => 
                commande.typeCommande === "Sur commande" &&
                commande.statutLiv !== StatutLivraison.LIVREE &&   
                commande.statutLiv !== StatutLivraison.ANNULEE &&
                (commande.statutLiv === StatutLivraison.NON_LIVREE || commande.statutLiv === StatutLivraison.PARTIELLE)
            )
            .map((commande: any) => ({
                value: commande.id,
                label: `${commande.refCom} [${commande?.client?.nomClient} ${commande?.client?.prenomClient}]`
            }));

    } catch (error) {
        //
    }
};
    watch(
          selectedCommande,
          (newCommandeId) => {
            if (newCommandeId) {
              magasins.forEach((magasin, index) => {
                magasin.produits = [
                  {
                    produit: "",
                   qtiteALivre: 0,
                    qtiteLivre :0,
                    qtiteRestante: 0,
                    produitOptions: [],
                  },
                ];
                magasin.produitOptions = [];
                if (magasin.magasin) {
                  fetchProduits(newCommandeId, magasin.magasin.split("|")[0], index);
                }
              });
            } else {
              magasins.forEach((magasin) => {
                magasin.produitOptions = [];
                magasin.produits.forEach((produit) => {
                  produit.produitOptions = [];
                });
              });
            }
          },
          { immediate: false }
        );


          watch(
            magasins,
            ()=>{
              magasins.forEach((magasin) =>{
                magasin.produits.forEach((produit)=>{
                  produit.qtiteRestante = produit.qtiteALivre - (produit.qtiteLivre || 0);

                });
              });
            },
            {deep:true}
          );
    onMounted(() => {
      fetchCommandes();
      fetchMagasins();
      fetchLivreurs();
    });

    return {
      livraisonSchema,
      addLivraison,
      livraisonForm,
      commandeOptions,
      userOptions,
      magasins,
      removeRowMagasin,
      removeRowProduit,
      addRowMagasin,
      addRowProduit,
      validateRowProduit,
      valuess,
      idLivraison,
      produitOptions,
      selectProd,
      selectMag,
      isDisable,
      getCurrentDate,
      magasinOptions,
      selectedCommande,
      
      
    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}
.marge-droite {
  margin-left: 87px;
}
.hr-longeur {
  width: 80%;
}
.bord1 {
  border: 1px solid #07a;
}
.fond {
  background-color: rgb(94, 191, 233);
}
</style>